import Vue from 'vue'
import VeeValidate from 'vee-validate'
import { rules, validator } from '@/tools/validator'

Vue.use(VeeValidate)

// vee-validate already have $validator
Vue.prototype.$formValidator = {
  rules: rules,
  async validate (data) {
    return this.validator.validateAll(data)
  },
  validator
}

Vue.prototype.$validationException = function (exception, addForm) {
  if (!exception.response) {
    return
  }
  if (addForm === undefined) {
    addForm = true
  }
  const errorResponse = exception.response.data
  if (!this.hasOwnProperty('$validator')) {
    return
  }

  this.$validator.errors.clear()

  if (!errorResponse.hasOwnProperty('errors')) {
    return
  }

  let errorFields = Object.keys(errorResponse.errors)

  errorFields.map(field => {
    let errorString = errorResponse.errors[field].join(', ')
    this.$validator.errors.add({ field: (addForm ? 'form.' : '') + field, msg: errorString })
  })
}
